/**
 * Where the viewer's language choice lives: localStorage, per browser.
 *
 * A cross-device preference would need a users column and a MeResponse field;
 * localStorage ships today and covers the real case — a delegate on their own
 * laptop. Promote to the DB later if roaming matters.
 *
 * localStorage throws in some privacy modes and inside sandboxed frames. A
 * storage failure must degrade to "detected language on next reload", never to
 * a white screen. (Same guard as auth/token-store.ts.)
 */

const LOCALE_KEY = "seagames.locale";

export function readStoredLocale(): string | null {
	try {
		return localStorage.getItem(LOCALE_KEY);
	} catch {
		return null;
	}
}

export function writeStoredLocale(locale: string): void {
	try {
		localStorage.setItem(LOCALE_KEY, locale);
	} catch {
		/* session-only preference; acceptable degradation */
	}
}
